// extracted by mini-css-extract-plugin
export default {"l_text_area_main":"Textarea_l_text_area_main__rAdgU","disabled":"Textarea_disabled__83+tY"};